import { DoorLockState, PressureMode, TemperatureMode } from 'dto/settings/enums';

import Enums from '../../base/enums';
import airdomeState from './AirdomeState';
import changeRequest from './ChangeRequest';
import lightState from './LightState';
import logLevel from './LogLevel';
import notificationChannel from './NotificationChannel';
import user from './user';

const enums: Enums = {
  user,
  notificationChannel,
  airdomeState,
  temperatureModes : {
    [TemperatureMode.Auto]: 'Auto',
    [TemperatureMode.Comfort]: 'Komfort',
    [TemperatureMode.Cutback]: 'Útlum',    
    disabled: 'Vypnuté'
  },
  pressureModes: {
    [PressureMode.Maximum]: 'Maximální',
    [PressureMode.Normal]: 'Normální',
  },
  logLevel,
  lightState,
  changeRequest,
  doorLockState: {
    [DoorLockState.Auto]: {
      short: 'Auto',
      full: 'Auto'
    },
    [DoorLockState.Unlocked]: {
      short: 'Odem.',
      full: 'Odemknuto'
    },
    [DoorLockState.Locked]: {
      short: 'Zam.',
      full: 'Zamknuto'
    }
  }
};

export default enums;
